import { render, staticRenderFns } from "./SafetyIncidentPage.vue?vue&type=template&id=0fc288b4"
import script from "./SafetyIncidentPage.vue?vue&type=script&lang=js"
export * from "./SafetyIncidentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports